import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-more',
  templateUrl: './more.component.html',
  styleUrls: ['./more.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoreIconComponent {}
